module.exports = __webpack_public_path__ + "img/整合营销_2@2x.dce5f092.png";